document.addEventListener('DOMContentLoaded', function () {
const descriptions = document.querySelectorAll('.collection-hero__description');

  descriptions.forEach(function (desc) {
    const maxHeight = 100; // hauteur max en px avant troncature

    if (desc.scrollHeight <= maxHeight) return;

    desc.style.maxHeight = maxHeight + 'px';
    desc.style.overflow = 'hidden';
    desc.style.transition = 'max-height 0.4s ease';

    const btn = document.createElement('button');
    btn.classList.add('read-more-btn');
    btn.textContent = 'Lire plus';

    btn.addEventListener('click', function () {
      if (desc.style.maxHeight === maxHeight + 'px') {
        desc.style.maxHeight = desc.scrollHeight + 'px';
        btn.textContent = 'Lire moins';
      } else {
        desc.style.maxHeight = maxHeight + 'px';
        btn.textContent = 'Lire plus';
      }
    });

    desc.insertAdjacentElement('afterend', btn);
  });
});
